module.exports = __webpack_public_path__ + "img/GVC005.6c66bb07.png";